export const getCorrectType = (type: string) => {
    if (type === 'agent' || type === 'developer') {
        return type;
    }
    return 'all';
};
